import React from 'react';

export default () => {
  const style = {
    display: 'block',
    background: 'url("/img/logo.svg") no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '297px',
    height: '70px',
    margin: 'auto'
  };

  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
  return <a className="logo" href="http://goodwix.com/" style={style} />;
};



// WEBPACK FOOTER //
// ./components/SecurityBoxLogo.jsx